import { createFileRoute } from '@tanstack/react-router';

import { BillingScreen } from '@/screens/settings/BillingScreen';

export const Route = createFileRoute('/_app/settings/billing')({
  component: BillingScreen,
});
